import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);
import ajax from "../plugins/axios.js";
import modules from "./modules/index.js";

export default new Vuex.Store({
    modules,
    state: {
        roles: [],
        userPhone: "",
        visible: false,
        regVisible: false, //注册弹窗
        loginVisible: false, //登陆弹窗
        forgetVisible: false, //忘记密码弹窗
        userInfoCache: "",
        loginMode: "1",
        metaInfo: {
            title: "",
            keywords: "",
            description: "",
        },
        packageCount: {
            productCount: 0, //产品套餐
            imageCount: 0, //图片套餐剩余量
        },
        shopToolToken: "",
        Sign: "", //二维码登录中的 二维码的唯一标识
        wxBinding: false, // 标识是不是微信公众号的绑定
        isActivityBanner: true,
        checkThesChecked: false, //检测词库的选择
        checkThesText: "选择某个行业词库", //检测词库的文案
        industryTesVisible: false, //行业弹窗
    },
    mutations: {
        setVisible(state, data) {
            state.visible = !!data;
        },
        setRegVisible(state, data) {
            state.regVisible = !!data;
        },
        setLoginVisible(state, data) {
            state.loginVisible = !!data;
        },
        setForgetVisible(state, data) {
            state.forgetVisible = !!data;
        },
        setUserInfoCache(state, data) {
            state.userInfoCache = data;
        },
        industryTesVisibleFun(state, data) {
            state.industryTesVisible = !!data;
        },
        setWxBinding(state, data) {
            state.wxBinding = !!data;
        },
        checkThesTextFun(state) {
            let userInfo = localStorage.getItem("userInfo");
            if (!userInfo) {
                return;
            }

            let config =
                JSON.parse(localStorage.getItem("userInfo")).kuaiOId + "config";
            if (
                localStorage.getItem(config) &&
                JSON.parse(localStorage.getItem(config)).IndustryCategorys
                    .length > 1
            ) {
                state.checkThesText = JSON.parse(
                    localStorage.getItem(config)
                ).IndustryCategorys[1];
            } else {
                state.checkThesText = "选择某个行业词库";
            }
        },
        checkThesCheckedFun(state, data) {
            state.checkThesChecked = data;
        },
        //判断用户状态
        checkUserStatus(state) {
            let userInfo = localStorage.getItem("userInfo");
            if (!userInfo) return (state.userPhone = "");
            userInfo = JSON.parse(userInfo);
            if (
                !userInfo.hasOwnProperty("expirationTime") ||
                !userInfo.hasOwnProperty("token") ||
                !userInfo.hasOwnProperty("userPhone")
            )
                return (state.userPhone = "");
            var dateBegin = new Date(); //获取当前时间
            var dateEnd = new Date(userInfo.expirationTime); //获取token过期时间
            var dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
            var leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
            var hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
            if (hours >= 24 || dateDiff <= 0) return (state.userPhone = "");
            state.userPhone = userInfo.userPhone;
        },
        //清除用户手机
        delUserPhone(state) {
            state.userPhone = "";
        },
        // 清除二维码签名
        delSign(state) {
            state.Sign = "";
        },
        //动态修改路由
        CAHNGE_META_INFO(state, metaInfo) {
            state.metaInfo = metaInfo;
        },
        changePackageCount(state, data) {
            state.packageCount = {
                productCount: data.productPackageQuantity,
                imageCount: data.imagePackageQuantity,
            };
        },
        checkeShopToolToken(state, data) {
            let shopToolToken = localStorage.getItem("shopToolToken");
            if (!shopToolToken) {
                localStorage.setItem("shopToolToken", data);
                state.shopToolToken = data;
                return;
            }
            if (shopToolToken == data) {
                return;
            }
            if (shopToolToken != data) {
                localStorage.setItem("shopToolToken", data);
                state.shopToolToken = data;
            }
        },
        delShopToolToken(state, data) {
            state.shopToolToken = data;
            localStorage.removeItem("shopToolToken");
        },
    },
    actions: {
        GetFwPackageQuantity({ commit }) {
            ajax.post(
                "/kuaio/api/ForbiddenWord/Package/GetFwPackageQuantity",
                {}
            ).then((res) => {
                if (res.code == 200) {
                    commit("changePackageCount", res.result);
                }
            });
        },
    },
});
